import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useUpdateRssPerkMutation = createMutationHook(
  MembershipsCreatorApiClient.updateRssPerk,
  {
    mutationKey: ['updateRssPerk'],
  },
)
